import { Component, EventEmitter, inject, Input, Output, ViewEncapsulation } from '@angular/core';
import { ExpandIndicatorComponent } from '../../../../../common/components/expand.indicator/expand.indicator.component';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { MatRadioButton, MatRadioChange, MatRadioGroup } from '@angular/material/radio';
import { CommonModule, NgIf } from '@angular/common';
import { SharedModule } from '../../../../shared/shared.module';
import { TripPlannerService } from '../../../services/trip.planner.service';
import { CreateItineraryCommand, Itinerary } from '../../../models/itinerary';
import { FormsModule } from '@angular/forms';
import { ButtonTriggerEvent } from '../../../../../common/components/button/button.component';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'ig-itinerary-details-style-editor',
  standalone: true,
  imports: [
    ExpandIndicatorComponent,
    MatCheckbox,
    MatMenu,
    MatRadioButton,
    MatRadioGroup,
    NgIf,
    SharedModule,
    FormsModule,
    CommonModule
  ],
  templateUrl: './itinerary.details.style.editor.component.html',
  styleUrl: './itinerary.details.style.editor.component.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'ig-itinerary-details-style-editor'
  }
})
export class ItineraryDetailsStyleEditorComponent {
  tripService = inject(TripPlannerService);
  applyToAll = false;
  isShow3dMapTip = false;
  @Input() currentItinerary: Itinerary;
  @Input() textColor = '#52525b';
  @Output() styleChange = new EventEmitter<any>();

  setDetailsStyle(event: ButtonTriggerEvent, trigger: MatMenuTrigger) {
    this.isShow3dMapTip = false;

    if (this.applyToAll) {
      this.tripService.updateDetailsStyleForAll(this.currentItinerary.hubName, this.currentItinerary.detailsStyle).pipe(
        finalize(() => {
          event.success();
          setTimeout(() => {
            trigger?.closeMenu();
          }, 5000);
        })
      ).subscribe(() => {
        this.styleChange.emit();
      });
    } else {
      this.tripService.updateItinerary(this.currentItinerary._id, this.mapItinerary()).pipe(
        finalize(() => {
          event.success();
          setTimeout(() => {
            trigger?.closeMenu();
          }, 5000);
        })
      ).subscribe(() => {
        this.styleChange.emit();
      });
    }
  }

  mapItinerary() {
    const command: CreateItineraryCommand = {
      hubName: this.currentItinerary.hubName,
      title: this.currentItinerary.title,
      description: this.currentItinerary.description,
      imageLink: this.currentItinerary.image,
      order: this.currentItinerary.order,
      isActive: this.currentItinerary.isActive,
      customFields: this.currentItinerary.customFields,
      detailsStyle: this.currentItinerary.detailsStyle,
      mapStyle: this.currentItinerary.mapStyle,
      defaultTravelMode: this.currentItinerary.defaultTravelMode
    };
    return command;
  }

  styleSelect() {
    this.isShow3dMapTip = this.currentItinerary.detailsStyle === 'map3d';
  }
}
